import {HttpEvent, HttpHandlerFn, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';


/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const baseUrlInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    if (!req.url.startsWith('http') && !req.url.startsWith('./') && !req.url.startsWith('icons') && !req.url.startsWith('api')) {
        const newReq = req.clone({ url: `${environment.baseUrl}/${req.url}` });
        return next(newReq)
    }
    return next(req)
};

